export const smoothScrollTo = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    const nav = document.querySelector('nav');
    const navHeight = nav ? nav.getBoundingClientRect().height : 80;
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - navHeight;
    
    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: 'smooth'
    });
  }
};
